import ApiService, { callCustomMethodAsync } from '../service/ApiService';

let moduleApi = {};
let moduleName = "user";

moduleApi.create = async (dataForm) => {
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id}
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id},
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.RequestAuthenticationTimwookEnt = async data => {
  let api = {
    module: moduleName,
    type: "RequestAuthenticationTimwookEnt",
    body: data,
    message: {
      success: "hidden",
      error: "Có lỗi xảy ra, vui lòng thử lại!"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.GetMyTodayTask = async data => {
  let api = {
    module: moduleName,
    type: "GetMyTodayTask",
    body: data,
    message: {
      success: "hidden",
      error: "Có lỗi xảy ra, vui lòng thử lại!"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.LoginOtherAccount = async data => {
  let api = {
    module: moduleName,
    type: "LoginOtherAccount",
    body: data,
    message: {
      success: "hidden",
      error: "Có lỗi xảy ra, vui lòng thử lại!"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.LogToken = async (data) => {
  let api = {
    module: moduleName,
    type: "LogToken",
    body: data,
    message: {
      success: "hidden",
      error: "Có lỗi xảy ra, vui lòng thử lại!"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
}

moduleApi.GetMyBackLog = async data => {
  let api = {
    module: moduleName,
    type: "GetMyBackLog",
    body: data,
    message: {
      success: "hidden",
      error: "Có lỗi xảy ra, vui lòng thử lại!"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

export default moduleApi;
